// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__12XyO","selected":"styles_selected__1NQV4"};